import { LoginForm } from '@/modules/auth/login-form';

export default function LoginPage() {
  return <LoginForm />;
}
